import React, { FC, useState, useCallback } from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import CameraPlayer from "./cameraPlayer/index";
import styles from "./style.module.css";
import { CameraMap } from "./map/InteractiveMap";
import camerasData from "./cameras.json";
import { Camera } from "./types";

const CameraPage: FC = () => {
  const { t } = useTranslation();
  const defaultCamera = camerasData.cameras.find(cam => cam.id === 9) as Camera;
  const [selectedCamera, setSelectedCamera] = useState<Camera | null>(defaultCamera);

  const handleCameraSelect = useCallback((cameraId: number) => {
    const camera = camerasData.cameras.find(cam => cam.id === cameraId);
    if (camera) {
      setSelectedCamera(camera as Camera);
    }
  }, []);

  const handleClosePlayer = useCallback(() => {
    setSelectedCamera(null);
  }, []);

  return (
    <>
      <Helmet>
        <title>{t("Камера")}</title>
      </Helmet>
      <div className={styles.container}>
        <div className={styles.title}>
          <div className={styles.title_header}>
            <h1>Камеры</h1>
          </div>
          <div className={styles.title_inner}>
            <img src="./homeicon.svg" alt="home" />
            <p>{t('Home')}</p>
            <img src="./arrowright.svg" alt="arrow" />
            <p>Камеры</p>
          </div>
        </div>

        <div className={styles.content}>
          <div className={styles.mapContainer}>
            <CameraMap 
              latitude={42.8746} 
              longitude={74.5698}
              onCameraSelect={handleCameraSelect}
            />
          </div>
          
          <div className={styles.playerContainer}>
            {selectedCamera ? (
              <div className={styles.playerWrapper}>
                <div className={styles.playerHeader}>
                  <h2 className={styles.playerTitle}>{selectedCamera.name}</h2>
                  <button 
                    className={styles.closeButton}
                    onClick={handleClosePlayer}
                    title="Закрыть видео"
                  >
                    <svg 
                      className={styles.closeIcon} 
                      viewBox="0 0 24 24" 
                      fill="none" 
                      stroke="currentColor" 
                      strokeWidth="2"
                    >
                      <line x1="18" y1="6" x2="6" y2="18" />
                      <line x1="6" y1="6" x2="18" y2="18" />
                    </svg>
                  </button>
                </div>
              
                  <CameraPlayer src={selectedCamera.url} cameraId={selectedCamera.id} />
                </div>
             
            ) : (
              <div className={styles.playerWrapper}>
                <div className={styles.playerHeader}>
                  <h2 className={styles.playerTitle}>Выберите камеру на карте</h2>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default CameraPage;
